import {commonActions} from '../../actions/commonActions';
import {areaGetItem} from '../../actions/areaActions';
import {connect} from 'react-redux';
import List from '../../components/area/StateList';
import {API_FETCH} from '../../services/FetchService';



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: () => {
        dispatch(list());
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = () => {
    return (dispatch, getState) => {
        API_FETCH.get('area').then(areaList => {
            dispatch(areaGetItem(areaList.data.lists));
        }).catch(error => {
            console.log(error);
        });
    }
}

const mapStateToProps = state => {
    return {
        areaList     : state.area.areaList,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);